import { Button } from '@/components/ui/button'
import { Text } from '@/components/ui/text'
import { useSlippageSettings } from '@/hooks/use-slippage'
import { CommonSettings } from '@/icons'
import { SLIPPAGE_WARNING } from '@/store/slippage'

export default function SettingButton({
  onClick,
  isFixedSwap,
  isBridge,
}: {
  onClick: () => void
  isFixedSwap: boolean
  isBridge: boolean
}) {
  const { slippage, suggestSlippage } = useSlippageSettings({ isFixedSwap, isBridge })
  const showWarning = slippage > SLIPPAGE_WARNING
  if (!showWarning)
    return (
      <Button variant='icon' size='sm' onClick={onClick}>
        <CommonSettings className='size-6' />
      </Button>
    )
  return (
    <Button
      onClick={onClick}
      size={'sm'}
      className='duration-300 text-main-100 items-center gap-1 border-none flex'
      variant='secondary'
    >
      <Text size={16} className={'text-main-100'}>
        {slippage !== suggestSlippage && `${slippage}%`}
      </Text>
      <CommonSettings className='md:size-5 size-4' />
    </Button>
  )
}
